module.exports = __webpack_public_path__ + "img/Shva_TalkBeforeAction.89005bb5.gif";